import { DropdownButton, MenuItem } from 'react-bootstrap';

interface IProps {
    activeKey: string,
    isAdmin: boolean,
    isAdminLogin: boolean,
    centerId: number,
}

const FollowUpNav = (props: IProps) => {
    const hrefPrefix = !props.isAdmin ? `/center/${props.centerId}/follow-up` : `/admin/follow-up`;

    const list = [
        { key: 'SURVEYS', title: 'Surveys', href: hrefPrefix + '/surveys/quick-to-do' },
        { key: 'DONORS', title: 'Donors', href: hrefPrefix + '/donors' },
        { key: 'REPORTS', title: 'Reports', href: hrefPrefix + '/reports/compliance' },
    ]

    const currentItem = list.find(x => x.key == props.activeKey);
    const currentItemTitle = currentItem?.title;

    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 5, backgroundColor: 'white' }}>
            <div className='h3' style={{ margin: 0 }}>{currentItemTitle}</div>

            <div>
                Section:&nbsp;
                <DropdownButton pullRight title={currentItemTitle} id='all-center-reports'>
                    {list.map(item =>
                        <MenuItem active={item.key == props.activeKey} href={item.href}>{item.title}</MenuItem>
                    )}
                </DropdownButton>
            </div>
        </div>
    );
}

export default FollowUpNav;